import { FC, useMemo } from "react"
import { ApplicationReview, useApplicationReviewState } from "../../../../core/applications"
import { KTSVG } from "../../../../../../_metronic/helpers"
import { useAuth } from "../../../../auth"


type Props = {
  review: ApplicationReview  
}

export const ApplicationReviewUserActionsCell: FC<Readonly<Props>> = ({review}) => {

  const { currentUser } = useAuth();

  const { showInspect } = useApplicationReviewState(state => state);

  const { canInspect, reviewId, inspectTitle, iconPath, btn_color } = useMemo(() => {

    const { state, id: reviewId, draft, type, assignedTo} = review;
    let iconPath='/media/icons/duotune/general/gen068.svg';
    
    if (! (assignedTo && assignedTo?.id && currentUser && currentUser?.id && currentUser.id === assignedTo.id)) {      
      return { canInspect: false, reviewId: 0, inspectTitle: '', draft: {}, iconPath };
    }
  
    let canInspect = false;    
    let inspectTitle = 'Submit Inspection';
    let btn_color = "btn-info";
    
    switch(state) {
      case 'Inspection - Inspection Kit':        
      case 'Inspection - Sampling':        
      case 'Inspection - CoC':
        if (type) inspectTitle = `Submit ${type}`;
        canInspect = true;
        break;
      case 'Inspection - Reschedule Sampling':
        iconPath = '/media/icons/duotune/general/gen014.svg';
        inspectTitle = 'Reschedule';
        canInspect = true;
        break;      
      case 'Inspection - Pending Sampling Report':
        inspectTitle = 'Submit Report';
        canInspect = true;
        break;
      case 'Issue - CoC':
        iconPath = '/media/icons/duotune/arrows/arr015.svg';
        inspectTitle = 'Submit Response';
        canInspect = true;
        btn_color = 'btn-danger';
        break;
      default:
        break;
    }
      
    return { canInspect, reviewId, inspectTitle, draft, iconPath, btn_color }

  }, [review, currentUser]);
    
  return (
  <>
  {(canInspect) &&
  <button 
    type='button' 
    className={`btn btn-sm ${btn_color} py-1 min-w-175px d-flex flex-row align-items-center justify-content-start`}
    onClick={() => {
      showInspect(reviewId)        
    }}
  >
    <KTSVG path={iconPath} className='svg-icon-3' />
    <div className="grow-1 text-center">
      {inspectTitle}
    </div>
  </button>
  }  
  </>
  )
}
